import React from 'react';

export default function MediaIcon() {
  return (
    <svg
      className="svg-icon"
      width="41px"
      height="35px"
      viewBox="0 0 41 35"
      role="img"
      aria-labelledby="media-icon-title"
    >
      <title id="media-icon-title">Media icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <ellipse
            cx="20.460039"
            cy="19.244521"
            rx="8.52504288"
            ry="8.72276869"
          />
          <path d="M37.5100448,5.28818925 L32.1028402,5.28818925 C31.419347,5.28818925 30.7774932,5.01563084 30.2938051,4.52154206 L27.176846,1.33228972 C26.3717914,0.508563084 25.3011559,0.0545443925 24.1622671,0.0545443925 L16.7578109,0.0545443925 C15.618922,0.0545443925 14.5482865,0.508563084 13.743232,1.33228972 L10.6262729,4.52154206 C10.1425848,5.01563084 9.50073099,5.28818925 8.81723782,5.28818925 L3.41003314,5.28818925 C1.52930799,5.28818925 0,6.85296729 0,8.77723131 L0,31.4563318 C0,33.3805958 1.52930799,34.9454556 3.41003314,34.9454556 L37.5101248,34.9454556 C39.39077,34.9454556 40.9201579,33.3806776 40.9201579,31.4563318 L40.9201579,8.77723131 C40.9201579,6.85296729 39.39077,5.28818925 37.5100448,5.28818925 Z M20.460039,29.7118107 C14.8189025,29.7118107 10.2300195,25.0164953 10.2300195,19.244521 C10.2300195,13.4725467 14.8189025,8.77723131 20.460039,8.77723131 C26.1011754,8.77723131 30.6900585,13.4725467 30.6900585,19.244521 C30.6900585,25.0164953 26.1011754,29.7118107 20.460039,29.7118107 Z M34.1000916,14.0108762 C33.1602086,14.0108762 32.395115,13.2280374 32.395115,12.2663551 C32.395115,11.3046729 33.1602086,10.5218341 34.1000916,10.5218341 C35.0399747,10.5218341 35.8050682,11.3046729 35.8050682,12.2663551 C35.8050682,13.2280374 35.0399747,14.0108762 34.1000916,14.0108762 Z" />
        </g>
      </g>
    </svg>
  );
}
